<template>
  <FormGroupHorizontal 
    :label="$t('engine.manageText.modalWidget.lblFont', languageEngine)"
    :labelValign="'center'"
    :split="'3:9'"
    :paddingClosest="'8'"
  >
    <FontFamily
      :fontFamily="_value"
      :menuMaxHeight="'300px'"
      :menuDrop="'left'"
      @change="onChange"
    />
  </FormGroupHorizontal>
</template>

<script>
import { mapGetters } from "vuex";
import FormGroupHorizontal from '@components_system/Shared/Tools/FormGroupHorizontal/FormGroupHorizontal';
import FontFamily from "@components_system/Shared/Tools/FontFamily/FontFamily";
import Quill from "quill";

export default {
  components: {
    FormGroupHorizontal,
    FontFamily,
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    value() {
      return this.texteditor.selectionFormatMerge.family;
    },
    _value() {
      if (Array.isArray(this.value)) return this.value[0];
      if (this.value && this.value.includes(',')) return this.value.split(',')[0];
      return this.value;
    }
  },
  methods: {
    onChange(value) {
      const selection = this.texteditor.editor.getSelection();
      let formatValue = `"${value}", Tahoma`;
      
      this.texteditor.editor.format("family", formatValue);
      this.setFormatLineBlank(selection, formatValue);
      this.setFormatListItem(selection);
    },
    setFormatLineBlank(selection, formatValue) {
      this.texteditor.editor.formatText({index: selection.index + selection.length, length: 0}, { family: formatValue });
    },
    setFormatListItem(selection) {
      const ListItem = Quill.import("formats/list/item");
      let [line1, offset1] = this.texteditor.editor.getLine(selection.index); // first line
      let lines = this.texteditor.editor.getLines(selection);
      if (!lines.length) {
        lines = [line1];
      }

      if (lines.length) {
        lines.forEach((line, i) => {
          let lineLength = line.length(); // with br
          let lineIndex = this.texteditor.editor.getIndex(line);
          let lineOffset = (i == 0) ? offset1 : 0;
          let lineSelection = {
            index: lineIndex + lineOffset,
            length: lineLength - lineOffset,
          };

          if (line instanceof ListItem) {
            if (line.children.length === 1) { // same color in line only
              const child = line.children.head;
              const attributes = child.attributes && child.attributes.attributes;

              if (attributes && attributes.family) {
                const family = attributes.family.value(child.domNode);
                this.texteditor.editor.formatLine(lineSelection, { 
                  'lineFontFamily': family, 
                  'listItemFontFamily': family,
                });
              }
            }
          } else { // block other
            this.texteditor.editor.formatLine(lineSelection, { 
              'lineFontFamily': null, 
              'listItemFontFamily': null,
            });
          }
        });
      }
    }
  },
}
</script>
